// Import hook
import { useEffect } from "react";



// Export hook
export const useArrowKeyNudge = ({
    isEnabled,
    onNudge,
    step = 0.01,
    shiftStep = 0.03,
}) => {

    // This attaches the keyboard listener
    useEffect(() => {

        // This exits if not enabled
        if (!isEnabled) {

            // This stops here
            return;

        }

        // This checks if the user is typing
        const isTypingElement = (target) => {

            // This reads the tag name
            const tagName = String(target?.tagName || "").toLowerCase();

            // This checks common input types
            return (
                tagName === "input" ||
                tagName === "textarea" ||
                tagName === "select" ||
                Boolean(target?.isContentEditable)
            );

        };

        // This handles the key press
        const handleKeyDown = (event) => {

            // This exits while typing
            if (isTypingElement(event.target)) {

                // This stops here
                return;

            }

            // This chooses the step size
            const currentStep = event.shiftKey ? shiftStep : step;

            // This handles left
            if (event.key === "ArrowLeft") {

                // This prevents scroll
                event.preventDefault();

                // This nudges left
                onNudge?.({
                    deltaX: -currentStep,
                    deltaY: 0,
                });

            }

            // This handles right
            if (event.key === "ArrowRight") {

                // This prevents scroll
                event.preventDefault();

                // This nudges right
                onNudge?.({
                    deltaX: currentStep,
                    deltaY: 0,
                });

            }

            // This handles up
            if (event.key === "ArrowUp") {

                // This prevents scroll
                event.preventDefault();

                // This nudges up
                onNudge?.({
                    deltaX: 0,
                    deltaY: -currentStep,
                });

            }

            // This handles down
            if (event.key === "ArrowDown") {

                // This prevents scroll
                event.preventDefault();

                // This nudges down
                onNudge?.({
                    deltaX: 0,
                    deltaY: currentStep,
                });

            }

        };

        // This adds the listener
        window.addEventListener("keydown", handleKeyDown, { passive: false });

        // This cleans up
        return () => {

            // This removes the listener
            window.removeEventListener("keydown", handleKeyDown);

        };

    }, [
        isEnabled,
        onNudge,
        step,
        shiftStep,
    ]);

};